import { useState, useEffect, useCallback } from "react";

/**
 * A custom hook to manage form-related API states such as pending requests and errors.
 * @param {boolean[]} isPendingArray - An array of boolean values indicating ongoing API requests.
 * @param {Error[]} errorArray - An array of errors from API requests.
 * @returns {Object} - Contains isPending, error, and resetError functions.
 */
const useFormApiState = (isPendingArray, errorArray) => {
  const [saveError, setSaveError] = useState(null);

  const saveIsPending = isPendingArray.some((pending) => pending);
  const combinedError = errorArray.find((err) => err);

  useEffect(() => {
    if (combinedError) {
      setSaveError(combinedError);
    }
  }, [combinedError]);

  const resetError = useCallback(() => {
    setSaveError(null);
  }, []);

  return { saveIsPending, saveError, resetError };
};

export default useFormApiState;
